module.exports = __webpack_public_path__ + "static/media/1026008.98ceae54.jpg";